import { ListPickupV2Components } from "@/app/infrastructures/dependencies/modules/ListPickupV2Components";
import {
  ListPickupParams,
  ListSttRequestPickupRequest,
  PickupCorporateSummaryRequest
} from "@/data/payload/api/ListPickupV2Request";
import { ListPickupDetail } from "@/domain/entities/ListPickupDetailV2";
import { RequestListPickupDetail } from "@/domain/entities/ListPickupV2";
import store from "@/store";
import { container } from "tsyringe";
import { Action, Module, VuexModule, getModule } from "vuex-module-decorators";
import { ListPickupV2Presenter } from "../presenters/ListPickupV2Presenter";

ListPickupV2Components.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "list-pickup-v2"
})
class ListPickupV2Store extends VuexModule {
  @Action
  getCargoTransportType(params: ListSttRequestPickupRequest) {
    const presenter = container.resolve(ListPickupV2Presenter);
    return presenter.getListSttRequestPickup(params);
  }

  @Action
  public getPickupCorporateSummary(params: PickupCorporateSummaryRequest) {
    const presenter = container.resolve(ListPickupV2Presenter);
    return presenter.getPickupCorporateSummary(params);
  }

  @Action
  public getListPickupDetail(payload: {
    id: string;
    params?: RequestListPickupDetail;
  }): Promise<ListPickupDetail> {
    const presenter = container.resolve(ListPickupV2Presenter);
    return presenter.getListPickupDetail(payload.id, payload.params);
  }

  @Action
  getListPickup(params: ListPickupParams) {
    const presenter = container.resolve(ListPickupV2Presenter);
    return presenter.getListPickup(params);
  }
}

export const ListPickupV2Controller = getModule(ListPickupV2Store);
